module.exports = __webpack_public_path__ + "static/media/suomi-100v.450a97bf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/suomi-100v.png
 ** module id = 412
 ** module chunks = 0
 **/